require('sticky-kit/dist/sticky-kit.js');

var dom = require('mode-front-end/resources/assets/js/dom/index');

export default (function(window, document, undefined) {

  var $ = window.jQuery;

  function init() {
    Breakpoints.on({
      name: "md",
      matched: function() {

        if (!$('.js-sticky-kit__child').length) {
          return false;
        }

        var hasInitialized = false;

        if (hasInitialized) {
          return false;
        }

        function calculateSticky() {
          var pageHeight = document.body.offsetHeight,
              pageWidth = document.body.offsetWidth,
              stickyHeight = document.querySelector('.js-sticky-kit__child').offsetHeight + 280; // header, footer, height of 'back' button + padding

          var bottomOptions = {
            parent: '.js-sticky-kit',
            offset_top: pageHeight - 100,
            bottoming: true,
            spacer: false
          };

          $('.js-sticky-kit__child-bottom').stick_in_parent(bottomOptions);

          // If window is too short, don't fix top sticky element
          if (stickyHeight > pageHeight) {
            $('.js-sticky-kit__child').trigger('sticky_kit:detach');
            return false;
          }
          else {
            $('.js-sticky-kit__child').stick_in_parent({
              parent: '.js-sticky-kit',
              offset_top: 50,
              bottoming: true,
              spacer: false
            });
            hasInitialized = true;
          }
        }

        calculateSticky();
        window.addEventListener('resize', function(){
          $('.js-sticky-kit__child').trigger('sticky_kit:detach');
          $('.js-sticky-kit__child-bottom').trigger('sticky_kit:detach');
          calculateSticky();
        });
      },
      exit: function(){
        $('.js-sticky-kit__child').trigger('sticky_kit:detach');
        $('.js-sticky-kit__child-bottom').trigger('sticky_kit:detach');
      },
    });
  }

  // ------------------------------
  // Public
  // ------------------------------

  return {
    init: init
  };

})(window, document);
